import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { languages } from 'app/utils/supportedLanguages';
import styles from './surveyLanguagesDropdown.module.scss';
export const SurveyLanguageDropdown = (props) => {
    const availableLanguages = languages.filter(({ code }) => props.languageSettings.filter((settings) => {
        return settings.language === code;
    }).length === 0);
    return (_jsx(DropdownButton, Object.assign({ noArrow: true, fixed: true, icon: "plus", buttonProps: { variant: 'secondary' }, dropdownProps: { className: styles.languagesDropdown }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: availableLanguages.map((language) => {
                    return (_jsx(ButtonList.Item, Object.assign({ onClick: () => props.handleGoToLanguage(language.code) }, { children: language.label }), language.code));
                }) })) }) }, { children: "Add language" })));
};
